<template>

    <div class="">

        <v-select
            v-model="selectedPayRate"
            :options="groupedPayRates"
            :clearable="!isDisabled"
            @search="fetchOptions"
            :disabled="isDisabled"
            label="name"
            placeholder="Select a Pay Rate"
            :reduce="option => option.heading ? null : option"
        >
            <template #option="option">
                <div v-if="option.heading" class="dropdown-heading">
                    {{ option.name }}
                </div>
                <div v-else :class="{ 'active-option': option.active, 'inactive-option': !option.active }">
                    {{ option.name }}
                </div>
            </template>
        </v-select>

        <input type="hidden" name="pay_rate_id" :value="selectedPayRate ? selectedPayRate.id : ''">

        <div v-if="errors.length > 0" >
            <div class="alert alert-danger mt-2" role="alert" v-for="(error, index) in errors" :key="index">
                {{ error }}
            </div>
        </div>

    </div>

</template>

<script>

import axios from "axios";
import debounce from "lodash/debounce";
import VSelect from 'vue-select';

export default {

    props: {
        payRate: {
            type: Object,
            default: () => {},
            required: false
        },
        old: {
            type: String,
            required: false
        },
        errors: {
            type: Array,
            required: false
        },
    },

    components: {
        VSelect
    },

    data() {
        return {
            selectedPayRate: null,
            payRates: [],
            isDisabled: false
        }
    },

    async mounted() {

        await this.fetchPayRates();

        if ( this.payRates.length === 1 ) {
            this.selectedPayRate = this.payRates[0];
        }

        if (this.payRate) {
            this.selectedPayRate = this.payRates.find(payRates => payRates.id === this.payRate.id);
        }

        if (this.old) {
            this.selectedPayRate = this.payRates.find(payRates => payRates.id === this.old);
        }

    },

    computed: {
        groupedPayRates() {

            const activeRates = this.payRates.filter(rate => rate.active);
            const inactiveRates = this.payRates.filter(rate => !rate.active);

            const result = [];

            if (activeRates.length > 0) {
                result.push({
                    name: 'Active',
                    heading: true,
                    id: 'active-heading'
                });

                result.push(...activeRates);
            }

            if (inactiveRates.length > 0) {
                result.push({
                    name: 'Inactive',
                    heading: true,
                    id: 'inactive-heading'
                });

                result.push(...inactiveRates);
            }

            return result;
        }
    },

    methods: {

        fetchOptions(search, loading) {
            if (search.length > 2) {
                this.debounceFetchOptions(search, loading);
            }
        },

        debounceFetchOptions: debounce(function (search) {
            this.fetchPayRates(search);
        }, 500),

        fetchPayRates(search) {
            return axios.get(route('api.movements.pay-rates.select'))
                .then(response => {
                    this.payRates = response.data.data;
                })
                .catch(error => {
                    console.error(error);
                });
        },

        updateSelectedPayRate() {
            if (this.payRates && this.payRates.length > 0) {
                this.selectedPayRate = this.payRates.find(rate => rate.id === this.payRate.id) || null;
            } else {
                this.selectedPayRate = null;
            }
        }

    },

}

</script>


<style scoped>

    .dropdown-heading {
        font-weight: bold;
        color: #495057;
        padding: 8px 0;
        border-bottom: 1px solid #dee2e6;
        pointer-events: none;
        user-select: none;
    }

    .inactive-option {
        color: #6c757d;
    }

</style>
